import * as AllDates from '@/enum/dates.enum.js';
import store from '@/pages/_root/store';

export function useDatesEnum() {
  if (!store || !store.getters) {
    console.warn('Vuex aún no está listo. useDatesEnum() llamado demasiado pronto.');
    return null;
  }
  const configYear = parseInt(STTEDRA_CONFIG_YEAR, 10);

  if (isNaN(configYear)) {
    throw new Error(
      'STTEDRA_CONFIG_YEAR no definido o no es un número en el .env',
    );
  }

  const selectedYear = store.getters['app/getProductYear'];

  const keyCurrent = `Dates${configYear}`;
  const keyPrevious = `Dates${configYear - 1}`;

  const map = {
    [configYear]: AllDates[keyCurrent],
    [configYear - 1]: AllDates[keyPrevious],
  };

  const selectedDates = map[selectedYear];

  if (!selectedDates) {
    throw new Error(
      `Año ${selectedYear} no soportado. Valores disponibles: ${configYear}, ${
        configYear - 1
      }`,
    );
  }

  return selectedDates;
}
